<template>
  <div>
    <!-- 标签管理 -->
    <baseBreadcrumb :page="$t('message.labelManagement')" :menu="$t('message.customerManagement')"></baseBreadcrumb>
    <!-- 主体 -->
    <div class="body">
      <div class="tabs">
        <el-tabs v-model="datas.status" type="card" @tab-click="handleClick">
          <!-- 综合标签 -->
          <el-tab-pane :label="$t('message.comprehensiveLabel')" name=""></el-tab-pane>
          <!-- 规则标签-->
          <el-tab-pane :label="$t('message.ruleTag')" name="1"></el-tab-pane>
          <!--  业务标签-->
          <el-tab-pane :label="$t('message.serviceLabel')" name="2"></el-tab-pane>
        </el-tabs>
        <div class="search">
          <div class="item">
            <el-input placeholder="请输入关键字搜索" v-model="datas.name"></el-input>
          </div>
          <el-button type="primary">
            {{ $t('message.search') }}
          </el-button>
        </div>
      </div>
      <div class="table">
        <el-table :data="tableData" :default-sort="{ prop: 'date', order: 'descending' }"
          :header-cell-style="{ background: '#EDEFF4' }" style="width: 100%">
          <!-- 标签名 -->
          <el-table-column align="center" :label="$t('message.tagName')">
          </el-table-column>
          <!-- 创建群体 -->
          <el-table-column align="center" :label="$t('message.createACommunity')">
          </el-table-column>
          <!-- 说明 -->
          <el-table-column align="center" :label="$t('message.instructions')">
          </el-table-column>
          <!-- 客户数 -->
          <el-table-column align="center" :label="$t('message.numberOfCustomers')" width="200">
          </el-table-column>
          <!-- 检索次数 -->
          <el-table-column align="center" :label="$t('message.retrievalTimes')" width="200">
          </el-table-column>
          <!-- 标签状态 -->
          <el-table-column align="center" :label="$t('message.labelStatus')" width="200">
          </el-table-column>
          <!-- 操作 -->
          <el-table-column align="center" :label="$t('message.operation')">
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="paginationContainer">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="datas.page"
          :page-sizes="[10, 20, 50, 100]" :page-size="datas.pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      datas: {
        pageSize: 10,
        page: 1,
      },
      total: 0,
      tableData: [],
    };
  },
  methods: {
    handleClick() { },
    // 分页
    handleCurrentChange(val) {
      this.data.page = val;
    },
    handleSizeChange(val) {
      this.data.pageSize = val;
    },
  },
};
</script>
<style lang='scss' scoped>
.search {
  margin: 20px 0;
  display: flex;

  .item {
    width: 240px;
    margin-right: 20px;
  }
}
</style>